module.exports = __webpack_public_path__ + "static/media/image_62.2ed00eff.png";